
  (function () {
    const details = document.querySelector('.search-style-full details-modal > details');
    if (!details) return;

    const summary = details.querySelector('summary');
    const mq = window.matchMedia('(min-width: 990px)');

    function syncOpen() {
      if (mq.matches) {
        details.open = true;
        if (summary) summary.style.display = 'none';
      } else {
        details.open = false;
        if (summary) summary.style.display = '';
      }
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', syncOpen);
    } else {
      mq.addListener(syncOpen);
    }

    syncOpen();
  })();
